import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Title } from 'thermia-react-container';
import LeadsTable from '../components/leadsTable';
import { LeadsState } from '../types/types';

const Active: FC = () => {
  const { t } = useTranslation('leads');

  useEffect(() => {
    document.title = t('leads.general.thermiaLeads');
  }, [t]);

  return (
    <>
      <Title text={`${t('leads.general.activeLeads')}`} />
      <LeadsTable leadsStatus={LeadsState.active} />
    </>
  );
};

export default Active;
